import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';

type ServiceQueryDetailKeyFilter = RequiredQueryKeyFilter;

type ServiceQueryListKeyFilter = RequiredQueryKeyFilter;

export const serviceQueryKeys = createDefaultQueryKeysGenerator<
  ServiceQueryListKeyFilter,
  ServiceQueryDetailKeyFilter
>({
  keyDataType: 'services',
});
